import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { MdPeopleAlt } from "react-icons/md";
import { RiMapPin2Fill } from "react-icons/ri";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faMicrochip,
  faUsers,
  faGlobeAsia,
} from "@fortawesome/free-solid-svg-icons";

function About() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-page">
      {/* Section 1: Hero */}
      <section
        id="company-profile"
        className="company-profile text-center"
        data-aos="fade-up"
      >
        <h2 className="profile-title">COMPANY PROFILE</h2>
        <p className="profile-subtitle">
          Learn More About Our Commitment and Craftsmanship
        </p>
      </section>

      {/* Section 2: Establishment */}
      <section
        className="established-section position-relative"
        data-aos="fade-up"
      >
        {/* Background image */}
        <img
          src="/images/BG - About Us.png"
          alt="Establishment"
          className="establishment-bg"
        />

        <div className="container d-flex flex-column flex-md-row align-items-start position-relative">
          {/* Year Info */}
          <div className="year-banner text-center text-md-start flex-shrink-0 me-md-4 mb-4 mb-md-0">
            <h5 className="fw-bold official-text">Officially established in</h5>
            <h1 className="display-1 fw-bold">2021</h1>
          </div>

          {/* Text Box */}
          <div className="established-text text-white">
            <p>
              <strong>
                PT Foremost Mebel Indonesia is an OEM and furniture manufacturer
                based in Indonesia.
              </strong>{" "}
              While we are recognized as a trusted OEM partner for global
              clients, we also proudly develop, manufacture, and market our own
              brand of mattresses, pillows, and comfort furniture.
            </p>
            <p>
              Our expertise spans a wide range of custom-made furniture and
              components, including mattresses, pillows, foam-based products,
              and various items tailored to client specifications whether in
              design, materials, or function. We provide comprehensive OEM
              services from product development and prototyping to material
              sourcing, mass production, and strict quality control supporting
              businesses in building their own branded collections.
            </p>
            <p>
              With a strong focus on consistency, customization, and timely
              delivery, we support our clients and grow our own brand by
              delivering production-ready furniture solutions thoughtfully
              tailored to the specific needs of their markets.
            </p>
          </div>
        </div>
      </section>

      {/* Section 3: Vision & Mission */}
      <section className="vision-mission-section" data-aos="fade-right">
        <div className="row g-4">
          {/* Vision */}
          <div className="col-md-6">
            <div className="card-box hover-card">
              <div className="face face1">
                <div className="content">
                  <h3>OUR VISION</h3>
                  <ul>
                    <li>
                      To become a trusted leader in Indonesia’s furniture
                      manufacturing industry, recognized for delivering
                      high-quality, customized OEM solutions that empower our
                      clients’ brands locally and, in the future, globally.
                    </li>
                    <li>
                      To promote responsible manufacturing by integrating
                      sustainability and innovation into our production
                      processes.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="face face2">
                <h2>Vision</h2>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-6">
            <div className="card-box hover-card">
              <div className="face face1">
                <div className="content">
                  <h3>OUR MISSION</h3>
                  <ul>
                    <li>
                      To deliver reliable, affordable, and tailor-made furniture
                      solutions that reflect our clients’ design and branding
                      goals.
                    </li>
                    <li>
                      To ensure excellence throughout manufacturing from
                      development and prototyping to sourcing, production, and
                      quality control.
                    </li>
                    <li>
                      To build lasting partnerships through transparency,
                      consistency, and customersatisfaction.
                    </li>
                    <li>
                      To support Indonesia’s furniture industry through
                      eco-conscious practices and export readiness.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="face face2">
                <h2>Mission</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Goal Section */}
      <section className="goals-section" data-aos="fade-in">
        <h3 className="section-title">OUR GOALS</h3>
        <div className="goals-container">
          <div className="goal-card">
            <FaCheckCircle className="goal-icon" />
            <h5>Enhance Product Quality and Consistency</h5>
            <p>
              Continuously improve manufacturing standards to deliver durable,
              functional, and aesthetically pleasing furniture that meets client
              expectations.
            </p>
          </div>

          <div className="goal-card">
            <MdPeopleAlt className="goal-icon" />
            <h5>Strengthen Client-Centric Solutions</h5>
            <p>
              Develop flexible OEM services that adapt to each client’s design,
              branding, and market requirements.
            </p>
          </div>

          <div className="goal-card">
            <RiMapPin2Fill className="goal-icon" />
            <h5>Expand Domestic Market Presence</h5>
            <p>
              Strengthen our footprint across key regions in Indonesia by
              building partnerships with local retailers, project contractors,
              and hospitality clients.
            </p>
          </div>
        </div>
      </section>

      {/* Section 5: Extended Goals with Diamond Images */}
      <section className="extended-goals-section py-5" data-aos="fade-down">

        <div className="container">
          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon icon={faLeaf} className="goal-icon" />
                </div>
                <div className="goal-text">
                  <h5>Promote Sustainable Manufacturing</h5>
                  <p>
                    Integrate eco-friendly materials and efficient
                    production methods to minimize environmental impact
                    and support green initiatives.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon
                    icon={faMicrochip}
                    className="goal-icon"
                  />
                </div>
                <div className="goal-text">
                  <h5>Invest in Innovation and Technology</h5>
                  <p>
                    Adopt modern tools, design software, and automation to
                    improve productivity and customization capabilities.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon icon={faUsers} className="goal-icon" />
                </div>
                <div className="goal-text">
                  <h5>Develop a Skilled and Motivated Workforce</h5>
                  <p>
                    Provide continuous training and career development to
                    ensure a safe, productive, and engaging work
                    environment.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon
                    icon={faGlobeAsia}
                    className="goal-icon"
                  />
                </div>
                <div className="goal-text">
                  <h5>Prepare for Regional Export Opportunities</h5>
                  <p>
                    Lay the foundation for future international growth by
                    aligning product standards with global market
                    expectations and building strategic export readiness.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Section 6 */}
      <section
        className="about-hero d-flex flex-column justify-content-center align-items-center text-white text-center"
        data-aos="zoom-out"
      >
        <h1>Original Makers. OEM Partners.</h1>
        <p>
          With flexible MOQ, fast production timelines, and a commitment to
          quality,
          <br />
          we help you bring your ideas to life, efficiently and reliably.
        </p>
      </section>

      {/* FOOTER SECTION */}
      <div
        className="footer-section text-white section-fade"
        style={{ backgroundColor: "#754c24" }}
        data-aos="fade-up"
      >
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div
              className="col-md-3 d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#5c3e1c", position: "relative" }}
            >
              <img
                src="/images/dotwall.jpg"
                alt="FORMEB Logo"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              />
              <div
                className="text-center py-4 px-3"
                style={{ zIndex: 1, position: "relative" }}
              >
                <img
                  src="/images/logo.png"
                  alt="FORMEB Logo"
                  style={{ maxWidth: "350px" }}
                />
                <p className="footer-tagline mt-2 fst-italic text-white">
                  Foremost Living Style
                </p>
              </div>
            </div>

            <div className="col-md-9 px-4 py-5">
              <div className="row text-start">
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light pe-4">
                  <h5 className="footer-title text-white">PRODUCTS</h5>
                  <ul className="list-unstyled footer-links">
                    <li>Mattresses</li>
                    <li>Pillows</li>
                    <li>Foams</li>
                  </ul>
                </div>
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">ABOUT US</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/about#company-profile"
                        className="text-white text-decoration-none"
                      >
                        Company Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Service
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Project Highlights
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        Careers
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 ps-4">
                  <h5 className="footer-title text-white">CONTACTS</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/contact"
                        className="text-white text-decoration-none"
                      >
                        Contact
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact"
                        className="text-white text-decoration-none"
                      >
                        Our Location
                      </Link>
                    </li>
                    <li className="mt-2">
                      <a
                        href="mailto:xxxxxx@gmail.com"
                        className="text-white me-3"
                      >
                        <i className="bi bi-envelope"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                        className="text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className="text-light my-4" />
              <div className="row">
                <div className="col-md-6">
                  <p className="footer-email fw-bold text-white">
                    contact@formeb.id
                  </p>
                  <address className="footer-address text-white mt-2">
                    PT. FOREMOST MEBEL INDONESIA
                    <br />
                    Jl. Gemilang, RT.002/RW.003, Tlajung Udik,
                    <br />
                    Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16963
                  </address>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4 small text-light">
                ©2025 Foremost Mebel Indonesia. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
